// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/today_user.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_users_v1_resources_identity } from "./identity_pb.js";

/**
 * Describes the file studyo/today/users/v1/resources/today_user.proto.
 */
export const file_studyo_today_users_v1_resources_today_user = /*@__PURE__*/
  fileDesc("CjBzdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL3RvZGF5X3VzZXIucHJvdG8SH3N0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMipgMKCVRvZGF5VXNlchIKCgJpZBgBIAEoCRIYChBmaXJlYmFzZV91c2VyX2lkGAIgASgJEjAKDGNyZWF0ZWRfdGltZRgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMgoObGFzdF9zZWVuX3RpbWUYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhEKCWZ1bGxfbmFtZRgFIAEoCRIVCg1lbWFpbF9hZGRyZXNzGAYgASgJEhkKEWlzX2VtYWlsX3ZlcmlmaWVkGAcgASgIEhMKC3BpY3R1cmVfdXJsGAggASgJEhQKDGN1bHR1cmVfbmFtZRgJIAEoCRIXCg9nb29nbGVfY2xpY2tfaWQYCiABKAkSGQoRZmFjZWJvb2tfY2xpY2tfaWQYCyABKAkSDQoFcm9sZXMYDCADKAkSPQoKaWRlbnRpdGllcxgNIAMoCzIpLnN0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMuSWRlbnRpdHkSGwoTaHViX3Nwb3RfY29udGFjdF9pZBgOIAEoCUInqgIkU3R1ZHlvLlRvZGF5LlVzZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_timestamp, file_studyo_today_users_v1_resources_identity]);

/**
 * Describes the message studyo.today.users.v1.resources.TodayUser.
 * Use `create(TodayUserSchema)` to create a new message.
 */
export const TodayUserSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_resources_today_user, 0);

